"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePayPeriodHourlyBreakdownView = void 0;
const utils_1 = require("../../../utils");
const react_i18next_1 = require("react-i18next");
const usePayPeriodHourlyBreakdownView = ({ payPeriodHourlyBreakdown, dataCell, timeTypeCell }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const data = [];
    Object.entries(payPeriodHourlyBreakdown).forEach(([payCode, breakdown]) => {
        if (breakdown.amount) {
            data.push({
                timeType: payCode,
                payPeriodTotal: (0, utils_1.getLocalizedDurationWithUnit)(breakdown.amount, breakdown.unit, t)
            });
        }
    });
    const columns = [
        {
            header: t('time_and_attendance_Timecard_PayPeriodHourlyBreakDown_TimeType'),
            cellComponent: timeTypeCell,
            width: '41%'
        },
        {
            header: t('time_and_attendance_Timecard_PayPeriodHourlyBreakDown_PayPeriodTotal'),
            cellComponent: dataCell,
            width: '41%'
        }
    ];
    return {
        data,
        columns
    };
};
exports.usePayPeriodHourlyBreakdownView = usePayPeriodHourlyBreakdownView;
